import React from 'react';

import { ContentDialog } from '@reckon-web/modal-dialog';

type ContentDialogProps = Parameters<typeof ContentDialog>[0];

export const useDialog = () => {
  const [dialog, setDialog] = React.useState<ContentDialogProps>();

  const Dialog = React.useCallback(
    () => (dialog ? <ContentDialog {...dialog} /> : null),
    [dialog]
  );

  const openDialog = React.useCallback(
    <T,>(
      Component: React.FC<{ onClose: (value?: T) => void }>,
      opts?: { size?: 'small' | 'medium' | 'large' }
    ): Promise<T | undefined> => {
      if (dialog?.isOpen) return Promise.resolve(undefined);

      return new Promise((resolve) => {
        const onClose = (value?: T) => {
          resolve(value);
          setDialog((dialog) => dialog && { ...dialog, isOpen: false });
        };

        setDialog({
          children: <Component onClose={onClose} />,
          isOpen: true,
          onClose,
          size: opts?.size,
        });
      });
    },
    [dialog]
  );

  return React.useMemo(
    () => [Dialog, openDialog] as [typeof Dialog, typeof openDialog],
    [Dialog, openDialog]
  );
};
